export const stripeConsumerEndpointPrefix = `/stripeConsumer` as const
export const stripeBusinessEndpointPrefix = `/stripeBusiness` as const
export const stripeOrganizationEndpointPrefix = `/stripeOrganization` as const
export const referralEndpointPrefix = `/referrals` as const
export const attributionEndpointPrefix = `/attribution` as const
export const avatarEndpoint = '/avatar'
export const mixpanelProxyEndpoint = '/analytics'
